import React from 'react';
import { Link } from 'react-router-dom';

export default function Unauthorized() {
  return (
    <div className="page-container">
      <div className="unauthorized-container">
        <h1>403 - Unauthorized</h1>
        <p>You don't have permission to access this page.</p>
        <div className="unauthorized-actions">
          <Link to="/home" className="button">Go to Home</Link>
          <Link to="/shop" className="button">Go to Shop</Link>
        </div>
      </div>
    </div>
  );
}
